import {IBookingManagementActionCreator,IBookingManagementActionTypes} from 'models/IBookingManagementState';

const initialState:{data:any[]} = {data:[]}

const reducer = (state = initialState, { type, payload }: IBookingManagementActionCreator) => {
    switch (type) {
      case IBookingManagementActionTypes.FETCH_PASSENGERS_REQUEST:
        return {
          ...state,
          data:[],
        }
      case IBookingManagementActionTypes.FETCH_PASSENGERS_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;